module.exports = __webpack_public_path__ + "media/packs/images/remarks-69b869dede3b06e1315bc2823eaf293b.svg";